import React from 'react';
import { SvgIcon } from '@material-ui/core';

const StarIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 44 48" {...props}>
      <path d="M42.7661 24.2617L1.2334 24.2617" stroke="white" strokeWidth="2.05607" strokeLinecap="round" />
      <path d="M32.7729 42.0151L11.2272 6.50813" stroke="white" strokeWidth="2.05607" strokeLinecap="round" />
      <path d="M11.2278 42.0149L32.7735 6.50788" stroke="white" strokeWidth="2.05607" strokeLinecap="round" />
      {/* <path d="M42.7661 24.2617L1.2334 24.2617" stroke="white" stroke-width="2.05607" stroke-linecap="round"/>
            <path d="M32.7729 42.0151L11.2272 6.50813" stroke="white" stroke-width="2.05607" stroke-linecap="round"/>
            <path d="M11.2278 42.0149L32.7735 6.50788" stroke="white" stroke-width="2.05607" stroke-linecap="round"/> */}
      <circle cx="22.4113" cy="24.4673" r="4.72897" />
      <circle cx="4.5232" cy="13.5703" r="2.46729" />
      <circle cx="4.5232" cy="34.9534" r="2.46729" />
      <circle cx="40.2991" cy="13.5703" r="2.46729" />
      <circle cx="22.7266" cy="45.0989" r="2.46729" transform="rotate(-60 22.7266 45.0989)" />
      <circle cx="22.0957" cy="3.42455" r="2.46729" transform="rotate(-60 22.0957 3.42455)" />
      <circle cx="40.2991" cy="34.9534" r="2.46729" />
      <path d="M35.9811 16.0468L8.22412 32.3567" stroke="white" strokeWidth="2.05607" strokeLinecap="round" />
      <path d="M8.22419 16.0468L35.9812 32.3567" stroke="white" strokeWidth="2.05607" strokeLinecap="round" />
      <path d="M22.1434 8.10476L22.0625 40.2988" stroke="white" strokeWidth="2.05607" strokeLinecap="round" />
      {/* <path d="M35.9811 16.0468L8.22412 32.3567" stroke="white" stroke-width="2.05607" stroke-linecap="round"/>
            <path d="M8.22419 16.0468L35.9812 32.3567" stroke="white" stroke-width="2.05607" stroke-linecap="round"/>
            <path d="M22.1434 8.10476L22.0625 40.2988" stroke="white" stroke-width="2.05607" stroke-linecap="round"/> */}
    </SvgIcon>
  );
};

export default StarIcon;
